<section class="p-2 py-4 p-md-5">
  <div class="">
    <div class="row">
      <div class="col-12 mb-3 show-on-small-screen">
        <div class="back-button">
          <span class="back-icon" (click)="editQuotation()"
            ><i class="fa-solid fa-arrow-left"></i
          ></span>
          <h4 class="back-button-heading mx-3">
            {{ "quo_premium" | translate }}
          </h4>
        </div>
      </div>
      <div class="col-md-3 mb-3">
        <div class="card quotation-info-card">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <div class="quotation-info-card-title">
                {{ "quo_num" | translate }}
              </div>
              <span class="edit-icon" (click)="editQuotation()"
                ><i class="fa-solid fa-pen"></i
              ></span>
            </div>
            <p class="quotation-info-card-content">
              {{ quotesInfo?.QuotationNumber }}
            </p>

            <div class="quotation-info-card-title">
              {{ "destinations" | translate }}
            </div>
            <p class="quotation-info-card-content">
              {{ quotesInfo?.DestinationCountryName }}
            </p>

            <div class="quotation-info-card-title">
              {{ "travel_dates" | translate }}
            </div>
            <p class="quotation-info-card-content">
              {{ quotesInfo?.FromDateString }} to {{ quotesInfo?.ToDateString }}
            </p>

            <div class="quotation-info-card-title">
              {{ "days" | translate }}
            </div>
            <p class="quotation-info-card-content">
              {{ quotesInfo?.NoofDays }} Days
            </p>

            <div class="quotation-info-card-title">
              {{ "num_of_travelers" | translate }}
            </div>
            <p class="quotation-info-card-content">
              {{ quotesInfo?.NoofTravellers }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-9 mb-3">
        <div class="mb-3 row m-0 p-0">
          <div class="col-8 m-0 p-0">
            <div class="back-button mb-3 show-on-md-screen">
              <span class="back-icon" (click)="editQuotation()"
                ><i class="fa-solid fa-arrow-left"></i
              ></span>
              <h4 class="back-button-heading mx-3">
                {{ "quo_premium" | translate }}
              </h4>
            </div>
          </div>
          <div class="col-3 m-0 p-0">
            <div class="button-section" *ngIf="quotesList.length > 0">
              <i
                class="fa-solid fa-scale-balanced mb-3 me-3 me-md-4"
                title="Compare Products"
                (click)="comparePremiumNewPage()"
              ></i>
              <i
                class="fa-solid fa-cloud-arrow-down mb-3 me-md-4"
                title="Download Quotation"
                (click)="DownloadQuotation()"
              ></i>
            </div>
          </div>
        </div>
        <section class="mb-3" *ngIf="quotesList.length > 0">
          <div class="table-responsive">
            <table class="table table-bordered table-width-80">
              <thead>
                <tr>
                  <th scope="col">{{ "sno" | translate }}</th>
                  <th scope="col">{{ "product_name" | translate }}</th>
                  <th scope="col">{{ "total_amount" | translate }}</th>
                  <th scope="col">{{ "action" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let quote of quotesList; let i = index">
                  <tr>
                    <td scope="row">{{ quote.Position }}</td>
                    <td scope="row">{{ quote.ProductName }}</td>
                    <td scope="row" class="text-end text-primary fw-bold">
                      <a
                        class="accordion-toggle amount-cell-link"
                        data-bs-toggle="collapse"
                        [attr.href]="'#collapse' + i"
                      >
                        {{ quote.sTotalAmount }}
                      </a>
                    </td>
                    <td scope="row" class="text-end">
                      <button
                        class="viewAndBuyPolicyButton px-3 py-1"
                        (click)="BuyPolicy(quote.QuotesID)"
                      >
                        View & Buy Policy
                      </button>
                    </td>
                  </tr>
                  <tr id="{{ 'collapse' + i }}" class="collapse">
                    <td colspan="4" class="text-center">
                      <table
                        *ngIf="quote.PremiumBreaks.length > 0"
                        class="table table-bordered table-striped table-width-80 mx-auto"
                      >
                        <thead>
                          <tr>
                            <th scope="col">S.No</th>
                            <th scope="col">Premium Information</th>
                            <th scope="col">Amount (KSh)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="
                              let premiumBreak of quote.PremiumBreaks;
                              let j = index;
                              let isLast = last
                            "
                          >
                            <td scope="row">
                              <div *ngIf="!isLast">{{ j + 1 }}</div>
                            </td>
                            <td scope="row">{{ premiumBreak.PremiumText }}</td>
                            <td
                              scope="row"
                              [ngClass]="{
                                'text-red': premiumBreak.isNegative,
                                'text-primary': !premiumBreak.isNegative
                              }"
                            >
                              {{ premiumBreak.PremiumValue | customCurrency }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div
                        class="text-center"
                        *ngIf="quote.PremiumBreaks.length == 0"
                      >
                        No Data
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </section>

        <section
          *ngIf="!isLoadingForQuotesList && quotesList.length == 0"
          class="py-md-3"
        >
          <p>
            Thank you for choosing your travel destinations for insurance
            coverage. Unfortunately, we currently do not have any products
            available for the selected country.
          </p>
          <p>
            Please try selecting a different destination to find suitable travel
            insurance options.
          </p>
          <div class="text-center">
            <button class="button2" (click)="BackToGetQuote()">
              Back to Get Quote
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>
</section>
